import './index.scss';
import React from 'react';

const ChatbotBenefits = ({ title }) => {
  return (
    <div className="chatbotbenefits">
      <div className="container">
        <h2>{title || 'Darum lohnt sich unser Chatbot'}</h2>
        <div className="chatbotbenefits__grid">
          <div className="chatbotbenefits__card">
            <h3>Effizienzsteigerung im Erstkontakt</h3>
            <p>
              33 % mehr Anfragen werden bereits beim ersten Kontakt erfolgreich gelöst – ohne menschliches Zutun.<sup><a href="https://www.capgemini.com/wp-content/uploads/2025/03/20th-March-Customer-service-transformation-CRI_Final.pdf#:~:text=operational%20efficiency.%20%E2%80%A2%2033,the%20value%20of%20customer%20service">1</a></sup>
            </p>
          </div>
          <div className="chatbotbenefits__card">
            <h3>24/7-Erreichbarkeit</h3>
            <p>
              64 % der Kunden schätzen die ständige Verfügbarkeit – keine Wartezeiten, keine Öffnungszeiten.<sup><a href="https://www.zendesk.de/blog/ai-impacting-cx-in-2023/">1</a></sup>
            </p>
          </div>
          <div className="chatbotbenefits__card">
            <h3>Höhere Kundenzufriedenheit</h3>
            <p>
              80% der Nutzer sind mit Chatbot-Antworten zufrieden – schnell, hilfreich und rund um die Uhr verfügbar.<sup><a href="https://uberall.com/en-us/company/press-releases/study-80-of-consumers-report-chatbot-experiences-as-positive-yet-nearly-60-still-lack-strong-enthusiasm-for-the-technology-according-to-new-uberall-study#:~:text=80%25%20of%20people%20who%20have%20interacted%20with%20a%20chatbot%20say%20the%20experience%20was%20generally%20positive.%20In%20fact,%2014%25%20of%20respondents%20called%20the%20chatbot%20interaction%20%E2%80%9Cvery%20positive.%E2%80%9D" target="_blank">1</a></sup>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotBenefits;
